// extracted by mini-css-extract-plugin
export default {"coverLink":"tN-z","contentBox":"uN-z","zapposPromoContainer":"vN-z","zapposPromoGroupContainer":"wN-z","promos":"xN-z","bottom":"yN-z","top":"zN-z","right":"AN-z","left":"BN-z"};